import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FeatureNavRoute } from './feature-nav.model';

@Injectable()
export class FeatureNavService {
  activeRoute$ = new BehaviorSubject<FeatureNavRoute | null>(null);
}
